import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCOBKlEMixPwcFd6OMi1ZVM-x_xJ3WdO8Y",
  authDomain: "schema-app-adbe5.firebaseapp.com",
  projectId: "schema-app-adbe5",
  storageBucket: "schema-app-adbe5.firebasestorage.app",
  messagingSenderId: "41226464174",
  appId: "1:41226464174:web:dc1022d0240757bfb5b63f",
  measurementId: "G-X5S7DWL4R8"
};

const app = initializeApp(firebaseConfig);

isSupported().then((yes) => {
  if (yes) getAnalytics(app);
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;